module.exports = __webpack_public_path__ + "static/media/BG-divider.ff0e4502.svg";